<template>
  <svg data-v-aebb818c="" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 21 21">
    <path fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          d="M10.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3m7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1"></path>
  </svg>
</template>
